@if (this.updateAvailable$ | async) {
  <div
    class="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-2 m-2 py-2"
    role="status"
  >
    <span>
      <i class="mdi mdi-update me-1"></i>
      {{ "GLOBAL_MSG_NEW_VERSION_AVAILABLE" | translate }}
    </span>
    <button type="button" class="btn btn-info btn-sm" (click)="reload()">
      {{ "GLOBAL_BTN_RELOAD" | translate }}
    </button>
  </div>
}
